import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetCategory = createAsyncThunk(
  "category/GetCategory",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(endPoint.GETCATEGORY);
      return response.data;      
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetCategorySlice = createSlice({
  name: "AllCategory",
  initialState: {
    AllCategory: [],
    error: null,
  },
  reducers: {
    clearAllCategory: (state) => {
      state.AllCategory = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetCategory.fulfilled, (state, action) => {
        state.AllCategory = action.payload;
      })
      .addCase(GetCategory.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearAllCategory } = GetCategorySlice.actions;
export default GetCategorySlice.reducer;
